(function () {
  const CLS_LOG_THRESHOLD = 0.05;

  const isIgnoredPath = window.location.pathname.indexOf('/venue-cabinet/') === 0
    || window.location.pathname.indexOf('/account/') === 0;

  // web-vitals lib requires Set
  const browserNotSupported = !window.Set;

  if (isIgnoredPath || browserNotSupported) {
    return;
  }

  const ENDPOINT = '/logging/tracking/custom_events_v1';

  function getNodeSelector(node) {
    if (!node) {
      return '';
    }

    const id = node.id ? `#${node.id}` : '';
    const classes = (node.className && node.className.trim) ? `.${node.className.trim().replace(/ /gmi, '.')}` : '';
    const nodeName = node.nodeName;

    return `${nodeName}${id}${classes}`;
  }

  function track(data) {
    if (!App.track) {
      return;
    }

    App.track.custom(ENDPOINT, {
      numeric_value: Math.round(data.value),
      value: `${window.innerWidth}x${window.innerHeight}`,
      category: 'web-vital',
      label: data.name,
    });
  }

  setTimeout(() => {
    window.webVitals.getFID(track);

    window.webVitals.getLCP(track);

    window.webVitals.getCLS((data) => {
      data.entries.forEach(entry => {
        if (entry.value < CLS_LOG_THRESHOLD || !entry.sources) {
          return;
        }

        const meta = entry.sources.map(source => {
          let nodeSelector = getNodeSelector(source.node);
          if (source.node && source.node.parentElement) {
            nodeSelector = `${getNodeSelector(source.node.parentElement)} > ${nodeSelector}`
          }

          return {
            id: nodeSelector,
            currentRect: source.currentRect,
            previousRect: source.previousRect,
          };
        });

        App.track.custom(ENDPOINT, {
          numeric_value: entry.value,
          category: 'web-vital',
          label: 'CLS',
          meta: JSON.stringify(meta, null, 2),
        });
      });
    });
  })
}());
